import { FunctionalComponent, h } from "preact";

import HomeNavGraphic from "components/home/navGraphic";
import Page from "components/page";
import { withStore } from "components/hocs/withStore";

import { LoadingState } from "stores/AppStore";

const Home: FunctionalComponent = withStore((props) => {
  const { store } = props;
  if (store.loadingState === LoadingState.LOADING) return null;

  return (
    <Page title="Home" description="A game of art whispered around the world">
      <HomeNavGraphic />
    </Page>
  );
});

export default Home;
